module.exports = __webpack_public_path__ + "static/media/Find_levers_5.8cb0847f.png";